module.exports = __webpack_public_path__ + "static/media/Logo.6ece809f.png";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/img/Logo.png
// module id = 579
// module chunks = 0